import styled from 'styled-components'

const StyledSectionContainer = styled.div`
  border: 1px solid #f2f2f2;
  border-radius: 9px;
  padding: 15px;
  margin: 20px 0px;

  & > div {
    & > .ant-form-item {
      margin: 0px
    }
  }

`
export {
  StyledSectionContainer
}
